import { useTranslation } from "react-i18next";

const useSectionSorting = () => {
  const { t } = useTranslation();

  return (a, b) => {
    const aOrder = a.type.order;
    const bOrder = b.type.order;

    if (aOrder === bOrder) {
      const aTitle = t(a.title);
      const bTitle = t(b.title);

      if (aTitle < bTitle) {
        return -1;
      }

      if (aTitle > bTitle) {
        return 1;
      }

      return 0;
    }

    if (aOrder < bOrder) {
      return -1;
    }

    if (aOrder > bOrder) {
      return 1;
    }
  };
};

export default useSectionSorting;
